import { Dictionary } from "lodash";
import { GetStrings } from "./ServerResourcesApiClient";

export class Resources {

    private static _instance: Promise<Resources>;
    private _loadedResources: Dictionary<string>;
    private _useSessionStorage;

    public constructor(useSessionStorage = false) {
        this._loadedResources = {};
        this._useSessionStorage = useSessionStorage;
    }

    public static async GetInstance() {
        if(!Resources._instance) {
            Resources._instance = new Promise(async (resolve) => {
                if(!Resources._instance) {
                    let instance = new Resources();
                    await instance.init();
                    resolve(instance);
                }
            });
        }
        return Resources._instance;
    }
    
    private async init() {
        if(this._useSessionStorage && window.localStorage["stringresources"]) {
            this._loadedResources = JSON.parse(window.localStorage["stringresources"]);
        }
        else {
            this._loadedResources = await GetStrings();
            window.localStorage["stringresources"] = JSON.stringify(this._loadedResources);
        }
    }

    public GetResource(key: string) {
        let val = this._loadedResources[key];
        //console.log(`Got resource: ${key} => ${val}`);
        if(val) return val;
        else return `??${key}??`;
    }
}